import React, { lazy, Suspense } from 'react'
const ProjectDetailPreviewPart = lazy(() => import('../../shared/previews/ProjectDetailPreviewPart'))

export default function ProjectDetailPreview({ projectDetail }) {
  return (
    <Suspense fallback={<div></div>}>
      <ProjectDetailPreviewPart projectDetail={projectDetail} />
    </Suspense>
  )
}